import { GameState, GetRoomData, Teleportsucces } from "@shared/types";
import { Page } from "../enums/Page";
import { css, html, htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";
import { MapService } from "../services/MapService";

const styles: string = css`
                    .bg {
                position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; 
    z-index: -1; 
}
        :host {
        font-family: "Onesize";
        width: 100%;
        max-width: 1024px;
        height: 100%;
            display: flex
;
    flex-direction: column;
    }
    .title { 
    flex:2;
    display: flex;
    align-items: center;
    justify-content: center;
    }
    .content{
    flex:10;
    display: flex;
    list-style: none;
    }
    .item{
    flex: 5;
    }
    .info{
    flex: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    }
    .img{
    flex:2;
    }
    .text{
    flex: 4;
    }
    .close {
    flex: 0;
    text-align: right;
    margin-bottom: 5px;
  }

  .close button {
    margin-left: 30px;
    background-color: #a05e2b;
    color: #fff;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
  }

  .close button:hover {
    background-color: #7f4622;
  }
    .roomlink {
        position: absolute;
        background: rgba(0, 0, 0, 0.6);
        color: #f4d47c;
        font-size: 1.2rem;
        padding: 50px 20px;
        border: 2px solid #a67c00;
        border-radius: 5px;
        cursor: pointer;
        text-decoration: none;
        transition: all 0.3s ease-in-out;
    }
    .roomlink:hover {
        background: rgba(255, 215, 0, 0.8);
        color: #000;
        transform: scale(1.1);
    }
    .roomlink:active {
        transform: scale(0.95);
    }

    #greathall { top: 40%; left: 10%; }
    #throneroom { top: 40%; left: 25%; }
    #royalchambers { top: 40%; left: 45%; }
    #library { top: 15%; left: 35%; }
    #kitchen { top: 15%; left: 55%; }
    #Courtyard { top: 65%; left: 30%; }
    #barracks { top: 40%; left: 65%; }
    #watchtower { top: 65%; left: 50%; }
    #dungeons { top: 65%; left: 75%; }
`;

export class MapComponent extends HTMLElement {
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();
    /** Instance of the game route service */
    private readonly _gameRouteService: GameRouteService = new GameRouteService();
    /** All rooms */
    private rooms: GetRoomData[] = [];

    private MapServices: MapService = new MapService();

    /**
    * The "constructor" of a Web Component
    */
    public async connectedCallback(): Promise<void> {
        void this.retrieveRooms();
        this.attachShadow({ mode: "open" });

        await this.refreshGameState();
        this.shadowRoot?.addEventListener("click", event => {
            if ((event.target as HTMLElement).id === "close") {
                this._gameEventService.switchPage(Page.Canvas);
            }
        });
        this.shadowRoot?.addEventListener("click", async event => {
            const target: HTMLElement = event.target as HTMLElement;
            if (target.classList.contains("roomlink")) {
                const roomAlias: string = target.id;
                console.log("Clicked room alias:", roomAlias);
                await this.teleportFunction(roomAlias);
                this._gameEventService.switchPage(Page.Canvas);
            }
        });
    }

    /**
    * Refresh the current game state
    */
    private async refreshGameState(): Promise<void> {
        const state: GameState = await this._gameRouteService.getGameState();

        this.updateGameState(state);
    }

    /**
     * Update the Map to the provided game state
     *
     * @param state Game state to update the canvas to
     */
    private updateGameState(state: GameState): void {
        // Handle switching pages, if requested.
        if (state.type === "switch-page") {
            this._gameEventService.switchPage(state.page as Page);

            return;
        }

        // Refresh the web component
        this.render();
    }

    /**
    * Render the contents of this page
    */
    private render(): void {
        const elements: HTMLElement[] = htmlArray`
                <style>
                ${styles}           
                </style>
                <img src="/assets/img/rooms/background.png" class="bg">
                ${this.renderTitle()}
                ${this.renderContent()}
                ${this.renderCloseButton()}
            `;
        if (this.shadowRoot) {
            while (this.shadowRoot.firstChild) {
                this.shadowRoot.firstChild.remove();
            }

            this.shadowRoot.append(...elements);
        }
    }

    /**
     * Render the title element
     *
     * @returns String with raw HTML for the title element.
     */
    private renderTitle(): string {
        return "<div class='title'>Map</div>";
    }

    /**
         * Render the content element
         *
         * @returns HTML element of the content
         */
    private renderContent(): HTMLElement {
        const contentElement: HTMLElement = html`
            <div class="content">
                ${this.rooms.map(room => html`
                    <a class="roomlink" id="${room.roomAlias}">
                        ${room.roomAlias}  <!-- Use roomAlias here -->
                    </a>
                `)}
            </div>
        `;

        return contentElement;
    }

    private async retrieveRooms(): Promise<void> {
        const data: GetRoomData[] = await this.MapServices.fetchRooms() as GetRoomData[];
        console.log("Retrieved rooms:", data);
        this.rooms = data;
        this.render();
    }

    private async teleportFunction(alias: string): Promise<void> {
        const data: Teleportsucces = await this.MapServices.teleportToRoom(alias);
        if (data.success) {
            console.log("Teleport successful to:", data.newRoom);
            await this.refreshGameState();
        }
        else {
            console.error("Failed to teleport to room:", alias);
        }
    }

    /**
     * Render the map element
     *
     * @returns String with raw HTML for the map element.
     */
    private renderCloseButton(): string {
        return `<div class="close">
        <button id="close">Close</button>
        </div>`;
    }
}
